import { render } from "./DeviceEditOwnerSlide.vue?vue&type=template&id=affec7da"
import script from "./DeviceEditOwnerSlide.vue?vue&type=script&lang=js"
export * from "./DeviceEditOwnerSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__